var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chart_container",staticStyle:{"border":"0px solid red","height":"100%"}},[_c('svg',{attrs:{"id":"gantt_chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }